export default `/* Ids Card Action */
:host {
  margin-inline-start: auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtY2FyZCIsInNvdXJjZXMiOlsiaWRzLWNhcmQtYWN0aW9uLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIENhcmQgQWN0aW9uICovXG46aG9zdCB7XG4gIG1hcmdpbi1pbmxpbmUtc3RhcnQ6IGF1dG87XG59XG4iXX0= */`;
